import { useApi } from '@mainstage/core-plugin-api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { customAlertApiRef } from '@agilelab/plugin-wb-platform';
import { notificationApiRef } from '../notificationApiRef';
import { WebhookPatchRequest } from '@agilelab/plugin-wb-notification-common';
import { WEBHOOK_KEY, WEBHOOKS_KEY } from './reactQuery';

export const useUpdateWebhook = () => {
  const notificationApi = useApi(notificationApiRef);
  const alertApi = useApi(customAlertApiRef);
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (request: WebhookPatchRequest) =>
      notificationApi.updateWebhook(request),
    onSuccess: (_, request) => {
      queryClient.invalidateQueries({ queryKey: [WEBHOOKS_KEY] });
      queryClient.invalidateQueries({ queryKey: [WEBHOOK_KEY, request.uuid] });
      alertApi.post({
        severity: 'success',
        message: 'Webhook updated successfully',
      });
    },
    onError: e => {
      alertApi.post({
        severity: 'error',
        message: (e instanceof Error ? e : new Error('Something went wrong'))
          .message,
      });
    },
  });
};
